import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { getWallet } from '../../api'
import actions, { load } from './actions'

// const getCompanySelect = state => state.companySelect

function* LOAD({ payload: { params } }) {
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(getWallet(companySelect, params), actions.LOAD))
}

function* COMPANY_SET() {
  yield put(load())
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, LOAD), takeEvery('company/save', COMPANY_SET)])
}
